const $inject = [];
export default class DatevBaseController {
  constructor ( ) {}
}

DatevBaseController.$inject = $inject;
